import React from 'react';
import styles from './LineLogo.module.css';

const LINE_LOGO_URL = 'https://assets.narvar.com/assets/line.svg';

const LineLogo = () => (
  <img className={styles.lineLogo} src={LINE_LOGO_URL} alt="line" />
);

export default LineLogo;
